import React from "react";
import Slider from "react-slick";
import "./Carousel.css";
import { MEDIA_URL } from "../../utils/constants";

function Carousel({ images }) {
  var settings = {
    arrows: true,
    autoplay: true,
    autoplaySpeed: 6000,
    dots: true,
    infinite: true,
    lazyLoad: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <Slider {...settings} className="slider-container">
      {images.map((image, index) => (
        <div key={index}>
            <img 
              src={MEDIA_URL + image} 
              alt={`Slide ${index + 1}`} 
              className="carousel-image" 
            />
        </div>
      ))}
    </Slider>
  );
}

export default Carousel;
